// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"6a654a4e","121":"abfe2e68","227":"82ad6d6a","258":"05726848","608":"e3fb3d11","648":"997f35d7"}[chunkId] + ".chunk.js";
};